import { pageConfig } from '@/common/service/page-config';

function equalsIgnoreCase(str1, str2) {
  return str1.toLowerCase() === str2.toLowerCase();
}

export const verifyAbandonCardForP2P = async () => {
  const isAbandonCartLinkValid = pageConfig.abandonInfo?.valid;
  const previousEmail = pageConfig.abandonInfo?.email;
  const currentEmail = SB?.user?.email;
  if (!isAbandonCartLinkValid) return Promise.reject('share link is invalid');
  if (!equalsIgnoreCase(previousEmail, currentEmail)) return Promise.reject('not same email');
  return Promise.resolve();
}
